import React from "react";
import { Formik, Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
import { formikSelectInput } from "../../../../../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { ReduxState } from "../../../../../redux";
import { Button, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  setSelectedAccount,
} from "../../../../../redux/reducers/TransactionManager";

import PeriodForm from "./NewPeriod";
import { createAlert } from "../../../../../redux/reducers/Alerts";
import { performBulkEdit } from "../../../../../docuclipper/api";
import {
  fetchMfs,
  setSelectedRowIds,
  setTls,
  toggleLoading,
} from "../../../../../redux/reducers/TransactionManager";
import { fetchTotals } from "../../../../../redux/reducers/Reconciler";
import { setSelectedChunk } from "../../../../../redux/reducers/TransactionManager";
import uuidv4 from "uuid/v4";
import { AccountForm2 } from "./NewAccount";

const validationSchema = Yup.object().shape({
  account: Yup.string(),
  period: Yup.string(),
});

export const SelectAccount = ({ transactionIds, setSelectionError }) => {
  const { job } = useSelector((state: ReduxState) => state.JobData);

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    const {
      account,
      period,
      isNewAccount,
      isNewPeriod,
      periodId,
      startDate,
      endDate,
      startBalance,
      endBalance,
    } = values;

    if (job) {
      dispatch(toggleLoading());
      performBulkEdit({
        jobId: job.id,
        operation: "assignToAccount",
        transactionIds,
        params: {
          account: {
            account,
            isNew: isNewAccount,
          },
          period: {
            chunk: period,
            id: periodId,
            isNew: isNewPeriod,
            startDate,
            endDate,
            startBalance,
            endBalance,
          },
        },
      })
        .then(({ transactions }) => {
          dispatch(toggleLoading());
          setSubmitting(false);
          resetForm();
          toggleShowEditAccount();

          dispatch(setTls({ transactions, resetPages: false }));

          dispatch(fetchTotals());
          dispatch(fetchMfs());
          dispatch(setSelectedRowIds({}));

          dispatch(setSelectedAccount(account));
          dispatch(setSelectedChunk(period || periodId));

          dispatch(
            createAlert({
              message: "Correction made successfully",
              timeout: 0,
              type: "success",
            })
          );
        })
        .catch((err) => {
          dispatch(toggleLoading());
          setSubmitting(false);
          dispatch(
            createAlert({
              message: "Error assigning transactions to account",
              timeout: 0,
              type: "error",
            })
          );
        });
    }
  };

  const {
    accountChunks: chunks,
    selectedChunk,
    accountChunkLabels,
  } = useSelector((state: ReduxState) => state.TransactionManager);

  const { accounts, selectedAccount } = useSelector(
    (state: ReduxState) => state.TransactionManager
  );

  const [showEditAccount, setShowEditAccount] = React.useState(false);
  const toggleShowEditAccount = () => {
    setShowEditAccount(!showEditAccount);
    setView("existing");
  };

  const dispatch = useDispatch();
  const [view, setView] = React.useState<
    "existing" | "newAccount" | "newPeriod"
  >("existing");
  return (
    <>
      <Button
        variant="light"
        disabled={transactionIds.length === 0}
        onClick={() => {
          if (transactionIds.length === 0) {
            setSelectionError("Select at least 1 row");
            return;
          }
          toggleShowEditAccount();
        }}
      >
        <FontAwesomeIcon icon="cog" />
        <span className="ml-1">Assign To Account/Period</span>
      </Button>

      <Formik
        enableReinitialize={true}
        initialValues={{
          account: selectedAccount,
          period: selectedChunk,
          isNewAccount: false,
          isNewPeriod: false,
          startDate: "",
          endDate: "",
          startBalance: "",
          endBalance: "",
          periodId: "",
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, errors, submitForm, setFieldValue, values }) => {
          return (
            <Form>
              <Modal
                size="lg"
                show={showEditAccount}
                onHide={toggleShowEditAccount}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Assign To Account/Period</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {view === "existing" && (
                    <div>
                      <strong>
                        <Form.Label>Account</Form.Label>
                      </strong>
                      <Field
                        name="account"
                        type="select"
                        component={formikSelectInput}
                        onChange={(e) => {
                          setFieldValue("account", e.target.value);
                          setFieldValue("isNewAccount", false);
                          dispatch(setSelectedAccount(e.target.value));
                        }}
                      >
                        {accounts.map((account, i) => (
                          <option key={i} value={account}>
                            {account}
                          </option>
                        ))}
                      </Field>
                    </div>
                  )}
                  {view === "newAccount" && (
                    <div className="m-3">
                      <Button
                        className="mb-4"
                        variant="link"
                        onClick={() => setView("existing")}
                      >
                        <FontAwesomeIcon icon="angle-left" />
                        <span className="ml-1">Back</span>
                      </Button>
                      <AccountForm2
                        onSubmit={({ account, startDate, endDate }) => {
                          setFieldValue("account", account);
                          setFieldValue("isNewAccount", true);

                          setFieldValue("period", "");
                          setFieldValue("isNewPeriod", true);
                          setFieldValue("periodId", uuidv4());
                          setFieldValue("startDate", startDate);
                          setFieldValue("endDate", endDate);

                          submitForm();
                        }}
                      />
                    </div>
                  )}
                  {view === "existing" && (
                    <div>
                      <strong>
                        <Form.Label>Period</Form.Label>
                      </strong>
                      <Field
                        name="period"
                        type="select"
                        component={formikSelectInput}
                        onChange={(e) => {
                          // setFieldValue("period", e.target.value);
                          setFieldValue("period", e.target.value);
                          setFieldValue("isNewPeriod", false);
                          dispatch(setSelectedChunk(e.target.value));
                        }}
                      >
                        {chunks.map((chunk, i) => (
                          <option key={i} value={chunk}>
                            {accountChunkLabels[chunk]}
                          </option>
                        ))}
                      </Field>
                      <Button
                        variant="link"
                        onClick={() => setView("newAccount")}
                      >
                        <FontAwesomeIcon icon="plus"></FontAwesomeIcon>
                        <span className="ml-1">Add Account/Period</span>
                      </Button>
                    </div>
                  )}
                  {view === "newPeriod" && (
                    <div className="m-3">
                      <Button
                        className="mb-4"
                        variant="link"
                        onClick={() => setView("existing")}
                      >
                        <FontAwesomeIcon icon="angle-left" />
                        <span className="ml-1">Back</span>
                      </Button>
                      <PeriodForm
                        onSubmit={({ startDate, endDate }) => {
                          setFieldValue("account", selectedAccount);
                          setFieldValue("isNewAccount", false);
                          setFieldValue("period", "");
                          setFieldValue("periodId", uuidv4());
                          setFieldValue("isNewPeriod", true);
                          setFieldValue("startDate", startDate);
                          setFieldValue("endDate", endDate);

                          submitForm();
                        }}
                      />
                    </div>
                  )}
                </Modal.Body>
                {view === "existing" && (
                  <Modal.Footer>
                    <Button
                      onClick={() => submitForm()}
                      disabled={isSubmitting}
                    >
                      Assign
                    </Button>
                  </Modal.Footer>
                )}
              </Modal>
              <Field type="hidden" name="isNewAccount" />
              <Field type="hidden" name="isNewPeriod" />
              <Field type="hidden" name="periodId" />
              <Field type="hidden" name="startDate" />
              <Field type="hidden" name="endDate" />
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default SelectAccount;
